var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('PanelPart',{attrs:{"maxWidth":"100%","color":"primary","icon":"mdi-filter","title":"Filtre"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default",null,{"setFilter":_vm.setFilter})]},proxy:true}],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }